// extracted by mini-css-extract-plugin
module.exports = {"nav":"Nav_nav__3gICw","link":"Nav_link__1CVGd","active":"Nav_active__XSt-p","exit":"Nav_exit__2Yq5l","icons":"Nav_icons__1jQLH"};